(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	/** Sürekli yapışkan header: scroll-up / gizleme yok; tema sınıfları (~ main vb.) için sticky işaretlenir. */
	class StickyHeader extends HTMLElement {
		connectedCallback() {
			this.sectionHeader = document.querySelector('.shopify-section-header')
			if (!this.sectionHeader) return
			this.sectionHeader.classList.add(
				'shopify-section-header-sticky',
				'shopify-section-header-always-sticky',
			)
		}

		disconnectedCallback() {
			if (this.sectionHeader) {
				this.sectionHeader.classList.remove(
					'shopify-section-header-sticky',
					'shopify-section-header-always-sticky',
				)
			}
		}
	}

	customElements.define('sticky-header', StickyHeader)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const mediaId = this.openedBy.getAttribute('data-media-id');
      const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);

      if (
        activeMedia &&
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();

      const popupSlider = this.querySelector('.js-popup-slider');
      if (popupSlider && popupSlider.swiper) {
        const slides = Array.from(popupSlider.querySelectorAll('.swiper-slide'));
        const targetIndex = slides.findIndex(function (slide) {
          var id = slide.getAttribute('data-media-modal-id');
          return id && id.endsWith('-' + mediaId);
        });
        if (targetIndex >= 0) {
          popupSlider.swiper.slideTo(targetIndex, 0);
        }
      }
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["va-taki-setleri"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('va-set-showcase')) {
    customElements.define('va-set-showcase', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.querySelectorAll('.va-sets__point').forEach(point => {
          const pin = point.querySelector('summary');
          let openedByHover = false;
          const openPoint = () => {
            this.querySelectorAll('.va-sets__point[open]').forEach(other => { if (other !== point) other.open = false; });
          };
          pin.addEventListener('pointerenter', event => {
            if (event.pointerType === 'mouse' && window.matchMedia('(hover: hover)').matches && !point.open) { openPoint(); point.open = true; openedByHover = true; }
          }, options);
          pin.addEventListener('click', event => {
            if (openedByHover && point.open && event.detail > 0) event.preventDefault();
            openedByHover = false;
          }, options);
          point.addEventListener('toggle', () => { if (point.open) openPoint(); else openedByHover = false; }, options);
          point.querySelector('[data-va-close]').addEventListener('click', () => { point.open = false; pin.focus({preventScroll:true}); }, options);
        });
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          const point = this.querySelector('.va-sets__point[open]');
          if (point) { point.open = false; point.querySelector('summary').focus({preventScroll:true}); }
        }, options);
        this.querySelectorAll('.va-sets__media').forEach(media => {
          media.addEventListener('pointerleave', event => {
            if (event.pointerType === 'mouse' && !media.contains(document.activeElement)) media.querySelectorAll('.va-sets__point[open]').forEach(point => { point.open = false; });
          }, options);
        });
        document.addEventListener('click', event => {
          this.querySelectorAll('.va-sets__point[open]').forEach(point => { if (!point.contains(event.target)) point.open = false; });
        }, options);
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
